module.exports = __webpack_public_path__ + "static/media/icon-manage-class-edit.765c2164.svg";